const generateQueryString = (filters: AuditFilters) => {
    let queryString = `page=${filters.page}`;
    if (filters.date) queryString += `&from=${filters.date[0]}&to=${filters.date[1]}`;
    if (filters.types && filters.types.length > 0) queryString += `&types=${filters.types.join('%')}`;
    if (filters.description) queryString += `&description=${filters.description}`;
    return queryString;
};

export default generateQueryString;
